import { render, staticRenderFns } from "./ShiXinLabelDialog.vue?vue&type=template&id=42c04b40&scoped=true"
import script from "./ShiXinLabelDialog.vue?vue&type=script&lang=js"
export * from "./ShiXinLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./ShiXinLabelDialog.vue?vue&type=style&index=0&id=42c04b40&prod&scoped=true&lang=css"
import style1 from "./ShiXinLabelDialog.vue?vue&type=style&index=1&id=42c04b40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c04b40",
  null
  
)

export default component.exports